<template>
	<div>
		<v-list nav>
			<v-list-item-group active-class="black--text">
				<v-list-item
					v-for="(position, i) in config.menu.main"
					:href="position.href || null"
					:to="position.component ? { name: position.component } : null"
					:exact="position.component != 'Groups' ? true : false"
					v-bind:key="'menu-position-' + i"
					:class="{'d-block d-sm-none': position.onlyMobile}"
				>
					<v-list-item-title>
						<div class="d-flex align-items-center">
							<div class="menu-icon-wrap">
								<v-icon class="menu-icon" color="accent">
									{{ position.icon }}
								</v-icon>
							</div>
							{{ $vuetify.lang.t(position.title) }}
						</div>
					</v-list-item-title>

				</v-list-item>
			</v-list-item-group>
		</v-list>
		<div class="group-name d-flex align-items-center">
			<div class="group-title">Szybki dostęp</div>
			<div class="group-line flex-grow-1 ml-3"></div>
		</div>
		<v-list nav class="nav-grey mt-3">
			<v-list-item-group>
				<v-list-item
					v-for="(position, i) in config.menu.quickMenu"
					:to="{ name: position.component }"
					exact
					v-bind:key="'menu-position-' + i"
				>
					<v-list-item-title>
						<div class="d-flex">
							<div class="menu-icon-wrap">
								<v-icon class="menu-icon" color="muted">
									{{ position.icon }}
								</v-icon>
							</div>
							{{ $vuetify.lang.t(position.title) }}
						</div>
					</v-list-item-title>
				</v-list-item>
			</v-list-item-group>
		</v-list>
		<div v-if="isManager">
			<div class="group-name d-flex align-items-center">
				<div class="group-title">{{ $vuetify.lang.t('$vuetify.layout.managerPanel') }}</div>
				<div class="group-line flex-grow-1 ml-3"></div>
			</div>
			<v-list nav class="nav-grey mt-3">
				<v-list-item-group>
					<v-list-item
						v-for="(position, i) in config.menu.managerMenu"
						:to="{ name: position.component }"
						v-bind:key="'menu-position-' + i"
					>
						<v-list-item-title>
							<div class="d-flex align-items-center">
								<div class="menu-icon-wrap">
									<v-icon class="menu-icon" color="muted">
										{{ position.icon }}
									</v-icon>
								</div>
								{{ $vuetify.lang.t(position.title) }}
							</div>
						</v-list-item-title>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</div>
	</div>
</template>

<script>
// MENU ITEMS MUST BE TRANSLATED BY VUETIFY LANG
import {mapGetters} from 'vuex';
import config from '@/config/sou.config.js'
export default {
	computed: {
		...mapGetters({
			user: 'auth/user'
		}),
		isManager() {
			if(this.user && this.user.role && this.user.role.role == 'manager') {
				return true;
			}
			return false;
		},
		config() {
			return config;
		}
	},
}
</script>
